<div class="confirmation-dialog">
  <h1 mat-dialog-title>{{'components.sprintDialog.deleteConfirmationTitle' | translate}}</h1>
  <div class="confirmation-button-row">
    <button (click)="confirmDeleteSprint()" mat-raised-button>
      <mat-icon>check</mat-icon>
      {{'components.sprintDialog.confirm' | translate}}
    </button>
    <button (click)="closeDeleteConfirmationDialog()" mat-raised-button>
      <mat-icon>close</mat-icon>
      {{'components.sprintDialog.decline' | translate}}
    </button>
  </div>
</div>
